import React from 'react';
import { Box, Typography } from '@mui/material';

const TodoCard = ({ text }: { text: string }) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      backgroundColor: '#e3f2fd',
      padding: 2,
      borderRadius: 1,
      marginBottom: 2,
      borderLeft: '4px solid #1976d2',
      maxWidth: '80%',
    }}
  >
    <Typography
      variant="body1"
      sx={{
        color: '#1a237e',
        fontSize: '1rem',
      }}
    >
      {text}
    </Typography>
  </Box>
);

export default TodoCard;
